import type { Paywall, PaywallCheckoutPreview } from "@circle-react/types";
import type { PaywallPrice } from "@circle-react/types/PaywallPrice";

import { isOneTimePrice } from "@/react/helpers/paywallPriceHelpers";
import { getQueryParam } from "@/react/helpers/urlHelpers";

// Extracted from `useCheckoutPaywallPrice` so non-form callers (e.g.
// conversion tracking) can resolve the same initial price without going
// through the checkout form's `paywall_price_id` field.
export const getQueryPaywallPriceId = (): number | undefined => {
  const queryPaywallPriceId = getQueryParam("price_id");
  if (!queryPaywallPriceId) {
    return undefined;
  }
  const parsed = parseInt(queryPaywallPriceId, 10);
  return isNaN(parsed) ? undefined : parsed;
};

export const getPaywallPrice = (
  paywall: Pick<Paywall, "prices">,
  priceId?: number,
): PaywallPrice => {
  let price: PaywallPrice | undefined;
  if (priceId) {
    price = paywall.prices.find(price => price.id === priceId);
  }
  if (!price) {
    const preferredPrice = paywall.prices.find(price => price.preferred);
    if (preferredPrice) {
      price = preferredPrice;
    } else {
      price = paywall.prices[0];
    }
  }
  return price;
};

export const getPaywallPriceAmount = (
  price: PaywallPrice,
  preview?: PaywallCheckoutPreview,
) => {
  if (preview) {
    return preview.amount_due_now;
  }

  let amount: number = 0;
  if (isOneTimePrice(price)) {
    amount = price.amount;
  } else {
    amount = price.upfront_payment_amount || price.amount;
  }

  return amount;
};
